import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["buttonsList", "pathButton", "wayDetails"]

  connect() {
    this.setupButtonEvents();
  }

  setupButtonEvents() {
    this.pathButtonTargets.forEach(button => {
      button.addEventListener('mouseenter', () => {
        const pathId = button.dataset.pathId;
        const mapElement = document.querySelector('[data-controller="home-map-panel"]');
        const mapController = this.application.getControllerForElementAndIdentifier(mapElement, 'home-map-panel');
        if (mapController) {
          const feature = mapController.highlightPathById(pathId);
          if (feature) {
            mapController.showTooltip(feature.properties.name);
          }
        }
      });

      button.addEventListener('mouseleave', () => {
        const mapElement = document.querySelector('[data-controller="home-map-panel"]');
        const mapController = this.application.getControllerForElementAndIdentifier(mapElement, 'home-map-panel');
        if (mapController) {
          mapController.clearPathHighlight();
          if (mapController.selectedFeature) {
            mapController.showTooltip(mapController.selectedFeature.properties.name);
          } else {
            mapController.hideTooltip();
          }
        }
      });
    });
  }

  findFeatureById(pathId, mapController) {
    const source = mapController.map.getSource('paths');
    if (!source) return null;

    const data = source._data;
    return data.features.find(f => f.properties.id === parseInt(pathId));
  }

  showDetails(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const pathId = button.dataset.pathId;

    // Cacher la liste des boutons
    this.buttonsListTarget.classList.add('hidden');

    // Cacher tous les détails
    this.wayDetailsTargets.forEach(details => {
      details.classList.add('hidden');
    });

    // Afficher les détails correspondants
    const details = this.wayDetailsTargets.find(d => d.dataset.pathId === pathId);
    if (details) {
      details.classList.remove('hidden');
    }

    // Sélectionner la voie correspondante
    const mapElement = document.querySelector('[data-controller="home-map-panel"]');
    const mapController = this.application.getControllerForElementAndIdentifier(mapElement, 'home-map-panel');
    if (mapController) {
      // Utiliser la nouvelle méthode pour sélectionner la trace par son ID
      const feature = mapController.selectPathById(pathId);
      if (feature) {
        mapController.showTooltip(feature.properties.name);
      }
    }
  }

  closeDetails(event) {
    if (event) event.preventDefault();
    
    // Cacher tous les détails
    this.wayDetailsTargets.forEach(detail => {
      detail.classList.add('hidden');
    });
    
    // Réafficher la liste des boutons
    this.buttonsListTarget.classList.remove('hidden');

    // Nettoyer la sélection sur la carte
    const mapElement = document.querySelector('[data-controller="home-map-panel"]');
    const mapController = this.application.getControllerForElementAndIdentifier(mapElement, 'home-map-panel');
    if (mapController) {
      mapController.clearSelection();
      mapController.clearPathHighlight();
      mapController.clearButtonHighlight();
      mapController.hideTooltip();
    }
  }
}
